import { dateFormate } from "@constants/index";
import dayjs from "dayjs";

export const SHIFT_TRANSFER_CONSTANTS = {
  FORM_LABELS: {
    SHIFT_TRANSFER_TITLE: 'Shift/ Transfer - New Facility Details',
    HIERARCHY_DETAILS: 'Hierarchy Details',
    COVERAGE_DETAILS: 'Coverage Details',
    EFFECTIVE_FROM_DATE: 'Effective From Date',
    STATE: 'State',
    DISTRICT: 'District',
    RURAL_URBAN: 'Rural/Urban',
    ULB: 'ULB',
    SUB_DISTRICT: 'Sub-District',
    BLOCK: 'Block',
    HEALTH_BLOCK: 'Health Block',
    SUB_DIVISION: 'Sub Division',
    VILLAGE: 'Village',
    GRAM_PANCHAYAT: 'Gram Panchayat / ADC Village',
    WARD: 'Ward',
    HFR_ID: 'HFR ID',
    HEALTH_FACILITY_TYPE: 'Health Facility Type',
    HEALTH_FACILITY_NAME: 'Health Facility Name',
    MOBILISER_TAGGED: 'Asha/ Mobiliser Tagged',
    HEALTH_PROVIDER_TAGGED: 'ANM/ Health Provider Tagged',
    WARDS_COVERED: 'Wards Covered',
    VILLAGES_COVERED: 'Villages Covered',
    GRAM_PANCHAYAT_COVERED: 'Gram Panchayat Covered'
  },

  ERROR_MESSAGES: {
    STATE_REQUIRED: 'State cannot be kept blank. Select user state from dropdown.',
    DISTRICT_REQUIRED: 'District cannot be kept blank. Select user District from dropdown.',
    EFFECTIVE_DATE_REQUIRED: 'Effective From Date cannot be kept blank. Enter Effective From Date.',
    RURAL_URBAN_REQUIRED: 'Select Rural or Urban from the dropdown.',
    ULB_REQUIRED: 'ULB cannot be kept blank when Urban is selected. Select ULB from dropdown.',
    HFR_ID_REQUIRED: 'HFR ID cannot be blank. Enter valid HFR ID.',
    FACILITY_TYPE_REQUIRED: 'Health Facility Type cannot be kept blank. Select an applicable option from Dropdown.',
    FACILITY_NAME_REQUIRED: 'Health Facility Name cannot be kept blank. Select an applicable option from Dropdown.',
    SHIFT_TRANSFER_SAME_DATE_ERROR: 'Cannot Shift/Transfer Facility on same date of Linking the Facility',
    SHIFT_TRANSFER_ERROR: 'Error occured while Shifting / Transfering Facility'
  },

  SUCCESS_MESSAGES: {
    SHIFT_TRANSFER_SUCCESS: 'Facility have been successfully Shifted/ Tranferred'
  },

  BUTTON_LABELS: {
    CANCEL: 'Cancel',
    SAVE_APPROVE: 'Save & Approve',
    SAVE_SUBMIT: 'Save & Submit'
  },

  USER_TYPES: {
    FACILITY_LEVEL: 'Facility Level User',
    FIELD_LEVEL: 'Field Level User'
  },

  GEO_TYPES: {
    RURAL: 'Rural',
    URBAN: 'Urban',
    RURAL_ID: '4485c41d-2142-43a2-b6d2-735b58caef09',
    URBAN_ID: 'faf5bda0-4c2b-45ac-afd2-33e97d985d3e'
  },

  API_ERRORS: {
    STATUS_500: 500,
    CHECK_EFFECTIVE_DATES: 'check_effective_dates',
    USER_FACILITY_TAGGED: 'user_facility_tagged'
  }
};

export const SHIFT_TRANSFER_FORM_DEFAULTS = {
  coverageShiftTransferObj: {
    hfr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    health_facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    health_facility_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: ''
    },
    mobiliser_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    wards_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    villages_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
    gram_panchayat_covered: {
      isError: false,
      message: '',
      isDisable: false,
      value: [],
      id: [],
      code: undefined
    },
  },

  shiftTransferObj: {
    villagesAndwards: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    rural_urban: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    state: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    district: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
      id: '',
      code: undefined
    },
    sub_district: {
      value: '',
    },
    remarks: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    }
  }
};

export const RURAL_URBAN_OPTIONS = [
  {
    value: 'Rural',
    label: 'Rural',
    id: '4485c41d-2142-43a2-b6d2-735b58caef09',
    code: 'R'
  },
  {
    value: 'Urban',
    label: 'Urban',
    id: 'faf5bda0-4c2b-45ac-afd2-33e97d985d3e',
    code: 'U'
  }
];

const formatValue = (obj: any, nameKey: string, codeKey: string) => {
  if (!obj || !obj[nameKey] || !obj[codeKey]) return '';
  if (obj[nameKey] === null || obj[codeKey] === null) return '';
  return `${obj[nameKey]}-${obj[codeKey]}`;
};

export const preShiftTransferDetails = (locationData: any, effecctiveFromDate: any) => {
  return {
    state: {
      value: formatValue(locationData.state, 'state_name', 'state_code'),
      id: locationData.state?.state_id || '',
      code: locationData.state?.state_code || '',
      isError: false,
      message: ''
    },
    district: {
      value: formatValue(locationData.district, 'district_name', 'district_code'),
      id: locationData.district?.district_id || '',
      code: locationData.district?.district_code || '',
      isError: false,
      message: ''
    },
    sub_district: {
      value: formatValue(locationData.sub_district, 'sub_district_name', 'sub_district_code'),
      id: locationData.sub_district?.sub_district_id || '',
      code: locationData.sub_district?.sub_district_code || '',
      isError: false,
      message: ''
    },
    block: {
      value: formatValue(locationData.block, 'block_name', 'block_code'),
      id: locationData.block?.block_id || '',
      code: locationData.block?.block_code || '',
      isError: false,
      message: ''
    },
    health_block: {
      value: formatValue(locationData.health_block, 'health_block_name', 'health_block_code'),
      id: locationData.health_block?.health_block_id || '',
      code: locationData.health_block?.health_block_code || '',
      isError: false,
      message: ''
    },
    sub_division: {
      value: formatValue(locationData.sub_division, 'sub_division_name', 'sub_division_code'),
      id: locationData.sub_division?.sub_division_id || '',
      code: locationData.sub_division?.sub_division_code || '',
      isError: false,
      message: ''
    },
    rural_urban: {
      value: locationData.urban_rual?.urban_rural_name === 'rural' ? 'Rural' : locationData.urban_rual?.urban_rural_name === 'urban' ? 'Urban' : '',
      id: locationData.urban_rual?.urban_rual_id || '',
      code: locationData.urban_rual?.urban_rural_code || '',
      isError: false,
      message: ''
    },
    ulb: {
      value: formatValue(locationData.ulb, 'ulb_name', 'ulb_code'),
      id: locationData.ulb?.ulb_id || '',
      code: locationData.ulb?.ulb_code || '',
      isError: false,
      message: ''
    },
    ward: {
      value: formatValue(locationData.ward, 'ward_name', 'ward_code'),
      id: locationData.ward?.ward_id || '',
      code: locationData.ward?.ward_code || '',
      isError: false,
      message: ''
    },
    village: {
      value: formatValue(locationData.village, 'village_name', 'village_code'),
      id: locationData.village?.village_id || '',
      code: locationData.village?.village_code || '',
      isError: false,
      message: ''
    },
    gram_panchayat: {
      value: formatValue(locationData.gram_panchayat, 'gram_panchayat_name', 'gram_panchayat_code'),
      id: locationData.gram_panchayat?.gram_panchayat_id || '',
      code: locationData.gram_panchayat?.gram_panchayat_code || '',
      isError: false,
      message: ''
    },
    effective_from_date: {
      value: effecctiveFromDate ? dayjs(effecctiveFromDate) : '',
      id: '',
      code: '',
      isError: false,
      message: ''
    }
  }
};

export const prePopulateCoverageDetails = (locationData: any) => {
  const linkedWards = Array.isArray(locationData?.linked_ward) ? locationData.linked_ward : [];
  const wardValues = linkedWards.map((ward: any) => `${ward.linked_ward_name}-${ward.linked_ward_code}`);
  const wardIds = linkedWards.map((ward: any) => ward.linked_ward_id);
  const wardCodes = linkedWards.map((ward: any) => ward.linked_ward_code);

  const linkedVillages = Array.isArray(locationData?.linked_village) ? locationData.linked_village : [];
  const villageValues = linkedVillages.map((village: any) => `${village.linked_village_name}-${village.linked_village_code}`);
  const villageIds = linkedVillages.map((village: any) => village.linked_village_id);
  const villageCodes = linkedVillages.map((village: any) => village.linked_village_code);

  const linkedGramPanchayats = Array.isArray(locationData?.linked_gram_panchayat) ? locationData.linked_gram_panchayat : [];
  const gramPanchayatValues = linkedGramPanchayats.map((gp: any) => `${gp.linked_gram_panchayat_name}-${gp.linked_gram_panchayat_code}`);
  const gramPanchayatIds = linkedGramPanchayats.map((gp: any) => gp.linked_gram_panchayat_id);
  const gramPanchayatCodes = linkedGramPanchayats.map((gp: any) => gp.linked_gram_panchayat_code);

  return {
    hfr_id: {
      value: locationData.facility_details.hfr_id || '',
      id: locationData.facility_details.facility_id || '',
      code: '',
      isError: false,
      message: ''
    },
    health_facility_name: {
      value: locationData.facility_details.facility_name || '',
      id: locationData.facility_details.facility_id || '',
      code: '',
      isError: false,
      message: ''
    },
    health_facility_type: {
      value: locationData.facility_details.facility_type_name || '',
      id: locationData.facility_details.facility_type_id || '',
      code: '',
      isError: false,
      message: ''
    },
    wards_covered: {
      value: wardValues,
      id: wardIds,
      code: wardCodes,
      isError: false,
      message: ''
    },
    villages_covered: {
      value: villageValues,
      id: villageIds,
      code: villageCodes,
      isError: false,
      message: ''
    },
    gram_panchayat_covered: {
      value: gramPanchayatValues,
      id: gramPanchayatIds,
      code: gramPanchayatCodes,
      isError: false,
      message: ''
    }
  }
};

export const hpShiftFinalData = (facilityId: any, formattedUserDetails: any, ashaMobilizerTaggedIds: any, isGrampanchayat: any, urbanRuralId: any, shiftTransferForm: any, coverageShiftTransferForm: any) => {
  return {
    facilityId: facilityId || null,
    healthProviderIds: formattedUserDetails?.usertype_name === SHIFT_TRANSFER_CONSTANTS.USER_TYPES.FIELD_LEVEL ? ashaMobilizerTaggedIds ? ashaMobilizerTaggedIds : [] : [],
    mobiliserIds: formattedUserDetails?.usertype_name === SHIFT_TRANSFER_CONSTANTS.USER_TYPES.FACILITY_LEVEL ? ashaMobilizerTaggedIds ? ashaMobilizerTaggedIds : [] : [],
    effectiveFromDate: new Date(dayjs(shiftTransferForm.effective_from_date.value).format(dateFormate.yyyy_mm_dd)).toISOString().split('T')[0],
    stId: formattedUserDetails.state_id || null,
    stCode: formattedUserDetails.state_code || null,
    distCode: shiftTransferForm.district.code || null,
    p_subDistId: shiftTransferForm.sub_district.id || null,
    ulbId: shiftTransferForm.ulb.id || null,
    blockId: shiftTransferForm.block.id || null,
    healthBlockId: shiftTransferForm.health_block.id || null,
    subDivisionId: shiftTransferForm.sub_division.id || null,
    wardId: shiftTransferForm.ward.id || null,
    villageId: isGrampanchayat ? null : shiftTransferForm.village.id || null,
    grampanchayatId: isGrampanchayat ? shiftTransferForm.gram_panchayat.id || null : null,
    urbanRuralId: urbanRuralId || null,
    linkedWardIds: shiftTransferForm.rural_urban.value?.toLowerCase() === 'urban' ? coverageShiftTransferForm.wards_covered.id : [],
    linkedVillageIds: shiftTransferForm.rural_urban.value.toLowerCase() === 'rural' ? isGrampanchayat ? [] : coverageShiftTransferForm.villages_covered.id : [],
    linkedGramPranchayatIds: shiftTransferForm.rural_urban.value.toLowerCase() === 'rural' ? isGrampanchayat ? coverageShiftTransferForm.gram_panchayat_covered.id : [] : [],
    distId: shiftTransferForm.district.id || null
  }
};

export const hpApprovalPayload = (healthProvider: any) => {
  return {
    facility_id: healthProvider.facilityId,
    linked_village_ids: healthProvider.linkedVillageIds,
    linked_ward_ids: healthProvider.linkedWardIds,
    gram_pranchayat_ids: healthProvider.linkedGramPranchayatIds,
    health_provider_ids: healthProvider.healthProviderIds,
    mobiliser_ids: healthProvider.mobiliserIds,
    effective_from_dt: healthProvider.effectiveFromDate,
    remarks: null,
    st_id: healthProvider.stId,
    dist_id: healthProvider.distId,
    sub_dist_id: healthProvider.p_subDistId,
    ulb_id: healthProvider.ulbId,
    block_id: healthProvider.blockId,
    health_block_id: healthProvider.healthBlockId,
    sub_division_id: healthProvider.subDivisionId,
    pc_id: null,
    lac_id: null,
    ward_id: healthProvider.wardId,
    village_id: healthProvider.villageId,
    grampanchayat_id: healthProvider.grampanchayatId,
    urban_rural_id: healthProvider.urbanRuralId
  }
}